const i18n = {
  title: 'Configuración de la distribución automática de actividades',
  description: 'Configure los parámetros para la distribución automática de actividades.',
  filters: 'Criterios',
  'filters.enable': 'Habilitar',
  'filters.distance': 'Distancia',
  'filters.distance.description': 'Considera un área de búsqueda.',
  'filters.schedule': 'Disponibilidad',
  'filters.schedule.description':
    'Busca usuarios que tienen disponibilidad para ejecutar la actividad. Utiliza la capacidad productiva y el tiempo de ejecución de una actividad.',
  'filters.users': 'Usuarios',
  'filters.users.description':
    'Aplica la búsqueda para todos los usuarios, solo en los usuarios relacionados o en usuarios específicos.',
  'filters.all_users': 'Todos los usuarios',
  'filters.related_users': 'Usuarios relacionados',
  'filters.selected': 'Usuarios específicos',
  distanceRadius: 'Distancia (km)',
  generalConfig: 'Configuración general',
  'generalConfig.daysLimit': 'Límite de días',
  'generalConfig.daysLimit.description':
    'Mientras no encuentre usuarios, busca en el próximo día hasta alcanzar el límite de días.'
}

export default i18n
